// Supabase Storage - images are stored with direct public URLs
// No more Strapi format variants (small/medium/large/thumbnail)

export function formatImageUrl(url?: string | null) {
  if (!url) return undefined;
  return url;
}

export interface ReviewImage {
  id: string;
  url: string;
  storage_path: string;
}

export function getSizedMediaLink(image?: ReviewImage | null) {
  if (!image) return null;
  return image.url;
}

export const AppIcon =
  'https://storage.googleapis.com/aquadesk.com/static/appIcons/app-logo-shadow.png';
